/**
 * API Configuration
 * Backend URL can be configured via VITE_API_BASE_URL environment variable
 * Default: http://localhost:8080 (for local development)
 * Production: set VITE_API_BASE_URL to empty string '' to use same origin (nginx proxy)
 */

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL,
} as const;
